import React from "react";
import MotivoRechazoModal from "../../Facturas/Management/MotivoRechazoModal";
export default MotivoRechazoModal;